export default __webpack_public_path__ + "static/media/Magnolia.cfb4ec0e.svg";